import { render } from "./Supermarket.vue?vue&type=template&id=a693bc32&scoped=true"
import script from "./Supermarket.vue?vue&type=script&lang=js"
export * from "./Supermarket.vue?vue&type=script&lang=js"

import "./Supermarket.vue?vue&type=style&index=0&id=a693bc32&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a693bc32"]])

export default __exports__